import { BankAccount } from './bankaccount';
import { CreditCard } from './creditcard';
import { DonationFrequency } from './donationfrequency';
import { PaymentMethod } from './paymentmethod';

export class Payment {
  public frequency: DonationFrequency;
  // public fixedAmount: number;
  public amount: number;
  public currency: string;

  public method: PaymentMethod;

  public issuerId: string; // iDeal
  public bankAccount: BankAccount; // DirectDebit
  public cardData: CreditCard; // CreditCard
  
  public beneficiaryGroupCode: string; // groupCode magnum

  constructor() {
    this.cardData = new CreditCard();
    this.bankAccount = new BankAccount();
  }

  public toString(): string {
    let resp = '';

    resp += 'frequency:' + this.frequency;
    // resp += ', fixedAmount:' + this.fixedAmount;
    resp += ', amount:' + this.amount;
    resp += ', method:' + this.method;

    resp += ', issuerId:' + this.issuerId;
    resp += ', bankAccount:' + this.bankAccount.toString();
    resp += ', card:' + this.cardData.toString();

    return resp;
  }

  public toJSON(): object {
    // return JSON.stringify(this, (k, v) => { return undefined; });
    const response = new Object();
    for (const attrKey in this) {
      if (this.hasOwnProperty(attrKey) && typeof attrKey === 'string' && this.include(attrKey as string)) {
        response[attrKey as string] = this[attrKey];
      }
    }

    return response;
  }

  private include(attribute: string): boolean {
    let include = true;

    const optionalAttributes = ['issuerId', 'bankAccount', 'cardData'];
    if (optionalAttributes.indexOf(attribute) >= 0) {
      switch (this.method) {
        case PaymentMethod.IDEAL:
          include = 'issuerId' === attribute;
          break;
        case PaymentMethod.CREDITCARD:
          include = 'cardData' === attribute;
          break;
        case PaymentMethod.DIRECTDEBIT:
          include = 'bankAccount' === attribute;
          break;
        default:
          include = false;
      }
    }

    return include;
  }
}
